import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionsComponent } from './actions/actions.component';
import { FormsModule } from '@angular/forms';
import { SelectTablesModule } from '../common/tables/tables.module';
import { AlarmsComponent } from './alarms/alarms.component';
import { CustomfieldssettingsComponent } from './customfields-settings/customfields-settings.component';
import { ModulesComponent } from './modules/modules.component';
import { TemplatesComponent } from './templates/templates.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { PaginationModule } from '../common/pagination/pagination.module';
import { WindowlistModule } from '../common/windowlist/windowlist.module';
import { UsersComponent } from './users/users.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { SystemComponent } from './system/system.component';
import { TemplateEmailComponent } from './template-email/template-email.component';
import { WindowModule } from '../common/window/window.module';
import { ToolbarmodelModule } from '../common/toolbarmodel/toolbarmodel.module';
//import { NgxTagsInputModule } from 'ngx-tags-input';
import { NgJsonEditorModule } from 'ang-jsoneditor' 
import { CustomfunctionsComponent } from './customfunctions/customfunctions.component';
import { CustomFunctionsDetailComponent } from './customfunctions/detail/detail.component';
import { TypesSettingsComponent } from './types/types.component';
import { BtnSelectFieldComponent } from './btn-select-field/btn-select-field.component';
import { Globals } from '../globals';
import { TaxesComponent } from './taxes/taxes.component';
import { TemplatesDetailComponent } from './templates/detail/detail.component';
import { UserComponent } from './users/list/detail/user.component';
import { WindowlistbuttonsModule } from '../common/windowlistbuttons/windowlistbuttons.module';
import { UsersListComponent } from './users/list/users.component';
import { UserGroupsComponent } from './users/usergroups/usergroups.component';
import { UserGroupComponent } from './users/usergroups/detail/usergroup.component';
import {UserlistsComponent} from './users/userlists/userlists.component';
import { AceModule } from 'ngx-ace-wrapper';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ACE_CONFIG } from 'ngx-ace-wrapper';
import { AceConfigInterface } from 'ngx-ace-wrapper';
import { NotificationsModule } from '../common/notifications/notifications.module';
import { UserlistComponent } from './users/userlists/detail/userlist.component';
import { FieldsModule } from "projects/c1-backend/src/app/modules/fields/fields.module";
import { CustomfieldssettingsDetailComponent } from './customfields-settings/detail/detail.component';
const DEFAULT_ACE_CONFIG: AceConfigInterface = {
};


@NgModule({
  declarations: [
    ActionsComponent,
    AlarmsComponent,
    CustomfieldssettingsComponent,
    CustomfieldssettingsDetailComponent,
    ModulesComponent,
    TemplatesComponent,
    TemplatesDetailComponent,
    UsersListComponent,
    UsersComponent,
    UserComponent,
    UserGroupsComponent,
    UserGroupComponent,
    UserlistsComponent,
    UserlistComponent,
    SystemComponent,
    TemplateEmailComponent,
    CustomfunctionsComponent,
    CustomFunctionsDetailComponent,
    TypesSettingsComponent,
    TaxesComponent,
    BtnSelectFieldComponent
  ],
  exports:[ActionsComponent,
    AlarmsComponent,
    CustomfieldssettingsComponent,
    ModulesComponent,
    TemplatesComponent,
    TemplatesDetailComponent,
    UsersComponent,
    UserlistsComponent,
    SystemComponent,
    TemplateEmailComponent,
    CustomfunctionsComponent,
    CustomFunctionsDetailComponent,
    TypesSettingsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SettingsRoutingModule,
    PaginationModule,
    WindowlistModule,
    WindowModule,
    ToolbarmodelModule,
    SelectTablesModule,
    AngularEditorModule,
    //CKEditorModule,
    NgxJsonViewerModule,
    //  NgxTagsInputModule,
    NgJsonEditorModule,
    WindowModule,
    ToolbarmodelModule,
    WindowlistbuttonsModule,
    NotificationsModule,
    FieldsModule
],providers:[
    {
      provide: ACE_CONFIG,
      useValue: DEFAULT_ACE_CONFIG
    }
  ]
})
export class SettingsModule { 
}
